import React from 'react';
import { journey } from '../../data/content';

/** Section 11 — the six volumes as one student journey. */
export function JourneySection() {
  return <section aria-labelledby="journey-heading" className="bg-brand-plum-dark px-5 py-16 text-white lg:px-8 lg:py-24" data-id="element-126" data-mp="2gcmzh2dmygbu">
      <div className="mx-auto max-w-6xl" data-id="element-127" data-mp="2p71autv1p6po">
        <h2 id="journey-heading" className="mx-auto max-w-2xl text-center font-display text-[2.1rem] font-bold leading-[1.08] sm:text-[2.75rem]" data-id="element-128" data-mp="2p82o94zja5ak">
          Designed Around the <em className="font-semibold italic text-brand-lilac" data-id="element-129" data-mp="1xgwwbbtyvdwd">Complete Student Journey</em>
        </h2>

        <ol className="relative mt-14 grid lg:grid-cols-6 lg:gap-4" data-id="element-130" data-mp="2bgfqf0py0opo">
          <span aria-hidden="true" className="absolute left-[8%] right-[8%] top-[22px] hidden h-px bg-white/20 lg:block" data-id="element-131" data-mp="26g0feft4vtav" />
          {journey.map((step, index) => <li key={step.stage} className="relative flex gap-5 pb-8 last:pb-0 lg:flex-col lg:items-center lg:pb-0 lg:text-center" data-id="element-132" data-mp="3mww70xd8hbe4" data-mpi={index}>
              {index < journey.length - 1 && <span aria-hidden="true" className="absolute bottom-0 left-[21px] top-11 w-px bg-white/20 lg:hidden" data-id="element-133" data-mp="2fsl15prdn6oh" />}
              <span className="relative flex h-11 w-11 flex-none items-center justify-center rounded-full border border-white/30 bg-brand-plum-dark font-display text-[1.15rem] font-bold text-brand-lilac" data-id="element-134" data-mp="2pr0qpoara7vv">
                {index + 1}
              </span>
              <div className="lg:mt-4" data-id="element-135" data-mp="1x3wi79cgfbfc">
                <p className="font-body text-[11px] uppercase tracking-[0.18em] text-white/55" data-id="element-136" data-mp="221fxmckw1u8v">Volume 0{index + 1}</p>
                <p className="mt-1 font-display text-[1.75rem] font-bold leading-none" data-id="element-137" data-mp="26zzkqgb7xc2t">{step.stage}</p>
                <p className="mt-2 text-[14px] leading-snug text-white/75" data-id="element-138" data-mp="2brreezpo7xx6">{step.verb}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-139" data-mp="1eblni2ryejsb">
          <p className="font-display text-[1.6rem] font-bold leading-snug sm:text-[1.9rem]" data-id="element-140" data-mp="1j9wv06us0i7d">
            Every core volume has a specific job.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-white/75 sm:text-[16px]" data-id="element-141" data-mp="16b5tbgsojz24">
            No random collection of unrelated ebooks. No unnecessary repetition.
          </p>
          <p className="mt-2 text-[15px] font-semibold leading-relaxed text-white sm:text-[16px]" data-id="element-142" data-mp="1l24x8eiklzfd">
            One connected professional education ecosystem.
          </p>
        </div>
      </div>
    </section>;
}